<script setup lang="ts">
import type { Widget } from '~/types/api'

const props = defineProps<{
  widget: Widget
}>()

const align = computed(() => {
  const align = props.widget.textAlign
  return align === 'right'
    ? 'justify-end'
    : align === 'center'
      ? 'justify-center'
      : ''
})

const { getResourceUrl } = useResources()
</script>

<template>
  <div
    class="overflow-hidden @4xl:min-w-[calc(100vw-250px)] @4xl:max-w-[calc(100vw-120px)] @4xl:px-2"
  >
    <div
      class="relative flex min-h-[300px] w-full flex-col items-center justify-center md:min-h-[520px] lg:min-h-[600px]"
      :class="{
        'max-md:bg-black': widget.textColor !== '#000000',
      }"
    >
      <div class="container flex h-full py-10" :class="align">
        <div
          class="z-20 mx-10 my-auto md:mx-20 md:w-1/4"
          :class="{
            'text-white': widget.textColor !== '#000000',
          }"
        >
          <TypographyH2>
            {{ widget.title }}
          </TypographyH2>
          <p class="text-sm">
            {{ widget.text }}
          </p>
          <NuxtLink
            v-if="widget.ctaLink && widget.ctaTitle"
            :to="widget.ctaLink"
          >
            <UiButtonBlackOutline
              v-if="widget.textColor === '#000000'"
              class="mt-6"
            >
              {{ widget.ctaTitle }}
            </UiButtonBlackOutline>
            <UiButtonWhiteOutline v-else class="mt-6">
              {{ widget.ctaTitle }}
            </UiButtonWhiteOutline>
          </NuxtLink>
        </div>
      </div>
      <NuxtImg
        v-if="widget.image?.url"
        class="pointer-events-none left-0 top-0 z-10 h-full w-full sm:object-cover md:absolute"
        :src="withHost(widget.image.url)"
        sizes="100vw sm:500px md:800px lg:1200px xl:1600px 2xl:2560px"
        :alt="widget.image?.metaAlt"
        :title="widget.image?.metaTitle"
      />
      <img
        v-if="widget.image?.url"
        class="pointer-events-none absolute left-0 top-0 h-full w-full scale-[10000%] select-none object-cover blur-[100px]"
        :src="getResourceUrl(widget.image.url + '/1920x1920/FIT')"
        :alt="widget.image?.metaAlt"
        :title="widget.image?.metaTitle"
      />
    </div>
  </div>
</template>
